module.exports = __webpack_public_path__ + "img/webeditor-5.9002851c.gif";